var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconoExterno(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25531",
    "data-name": "Grupo 25531",
    transform: "translate(-1681 -126)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69312",
    "data-name": "Trazado 69312",
    d: "M438.99,308.667a.922.922,0,0,0-1.3,0h0l-2.818,2.817a.308.308,0,0,1-.435,0l-2.817-2.817a.922.922,0,1,0-1.3,1.3l2.818,2.818a2.151,2.151,0,0,0,3.042,0h0l2.818-2.818A.931.931,0,0,0,438.99,308.667Z",
    transform: "translate(1267.351 -163.908)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25482",
    "data-name": "Grupo 25482",
    transform: "translate(1681 126)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_2133",
    "data-name": "Elipse 2133",
    cx: 24,
    cy: 24,
    r: 24,
    transform: "translate(0 0)",
    fill: "#003763"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_69328",
    "data-name": "Trazado 69328",
    d: "M19.274,10.6v7.71a4.824,4.824,0,0,1-4.819,4.819H4.819A4.824,4.824,0,0,1,0,18.311V8.673A4.824,4.824,0,0,1,4.819,3.855h7.71a.964.964,0,1,1,0,1.927H4.819A2.9,2.9,0,0,0,1.927,8.673v9.637A2.9,2.9,0,0,0,4.819,21.2h9.637a2.9,2.9,0,0,0,2.891-2.891V10.6a.964.964,0,1,1,1.927,0ZM20.238,0H13.492a.964.964,0,1,0,0,1.927h6.347L7.992,13.774a.964.964,0,1,0,1.363,1.363L21.2,3.29V9.637a.964.964,0,1,0,1.927,0V2.891A2.9,2.9,0,0,0,20.238,0Z",
    transform: "translate(1693.435 138.553)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoExterno);
export default __webpack_public_path__ + "static/media/Icono-Externo.acec41d8effc634d47326faa469eb746.svg";
export { ForwardRef as ReactComponent };